/**
 * HomeworkDueBadge, a tiny red count that rides on the "Learn" nav item when
 * the learner has homework due today or tomorrow, so kids notice before they
 * even open My Homework. Self-contained: fetches its own data and renders
 * nothing when there's nothing due.
 */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { API, useApp } from "../../context";
import { getActiveLearnerId } from "../../hooks/useActiveLearner";

export default function HomeworkDueBadge() {
  const { user } = useApp();
  const userId = getActiveLearnerId(user?.id || user?.email) || user?.id || user?.email;
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!userId) return;
    let alive = true;
    const today = new Date().toISOString().slice(0, 10);
    const tomorrow = new Date(Date.now() + 86400000).toISOString().slice(0, 10);
    axios.get(`${API}/tutor/homework/list/${encodeURIComponent(userId)}?include_done=true`)
      .then((r) => {
        if (!alive) return;
        const due = (r.data.sessions || []).filter(
          (s) => !s.completed && s.due_date && (s.due_date === today || s.due_date === tomorrow)
        );
        setCount(due.length);
      })
      .catch(() => {});
    return () => { alive = false; };
  }, [userId]);

  if (!count) return null;
  return (
    <span
      data-testid="nav-homework-due-badge"
      title={`${count} homework ${count === 1 ? "assignment" : "assignments"} due soon`}
      className="absolute -top-1.5 -right-3 min-w-[16px] h-4 px-1 rounded-full bg-red-500 text-white text-[9px] font-bold flex items-center justify-center leading-none border border-red-300/50 animate-pulse"
    >
      {count > 9 ? "9+" : count}
    </span>
  );
}
